import { __decorate, __metadata } from "tslib";
import { Sim } from '@dooboostore/simple-boot';
export var LottoService;
(function (LottoService) {
    LottoService.SYMBOL = Symbol.for('LottoService');
})(LottoService || (LottoService = {}));
// 팩토리: Accommodation 패턴
export default (container) => {
    let LottoServiceImpl = class LottoServiceImpl {
        constructor() {
            Object.defineProperty(this, "cache", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: new Map()
            });
            Object.defineProperty(this, "CACHE_KEY", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'lotto_results_cache'
            });
            Object.defineProperty(this, "API_URL", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://www.dhlottery.co.kr/lt645/selectPstLt645InfoNew.do'
            });
            Object.defineProperty(this, "MAIN_INFO_URL", {
                enumerable: true,
                configurable: true,
                writable: true,
                value: 'https://www.dhlottery.co.kr/selectMainInfo.do'
            });
            this.loadCache();
        }
        loadCache() {
            try {
                const stored = localStorage.getItem(this.CACHE_KEY);
                if (stored) {
                    const data = JSON.parse(stored);
                    this.cache = new Map(Object.entries(data).map(([k, v]) => [Number(k), v]));
                }
            }
            catch (e) {
                // ignore
            }
        }
        saveCache() {
            try {
                const obj = Object.fromEntries(this.cache);
                localStorage.setItem(this.CACHE_KEY, JSON.stringify(obj));
            }
            catch (e) {
                // ignore
            }
        }
        async fetchRounds(cursor) {
            try {
                const url = `${this.API_URL}?srchDir=older&srchCursorLtEpsd=${cursor}`;
                const response = await fetch(url);
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const list = json.data?.list || [];
                list.forEach(item => {
                    this.cache.set(item.ltEpsd, item);
                });
                this.saveCache();
                return list;
            }
            catch (e) {
                console.error('[LottoService] Fetch failed:', e);
                return [];
            }
        }
        async getLatestRoundNumber() {
            try {
                const response = await fetch(this.MAIN_INFO_URL);
                if (!response.ok)
                    throw new Error(`HTTP error! status: ${response.status}`);
                const json = await response.json();
                const lt645List = json.data?.result?.pstLtEpstInfo?.lt645 || [];
                if (lt645List.length === 0)
                    return 0;
                const maxRound = Math.max(...lt645List.map((item) => item.ltEpsd));
                // 메인 정보에서 가져온 데이터도 캐싱
                lt645List.forEach((item) => {
                    this.cache.set(item.ltEpsd, item);
                });
                this.saveCache();
                return maxRound;
            }
            catch (e) {
                console.error('[LottoService] Failed to get latest round number:', e);
                return 0;
            }
        }
        async getLottoRound(round) {
            if (this.cache.has(round)) {
                return this.cache.get(round);
            }
            const list = await this.fetchRounds(round + 1);
            return list.find(item => item.ltEpsd === round);
        }
        async getLottoList(startRound, count) {
            const results = [];
            for (let i = 0; i < count; i++) {
                const round = startRound - i;
                if (round < 1)
                    break;
                if (this.cache.has(round)) {
                    results.push(this.cache.get(round));
                }
                else {
                    // 캐시에 없는 구간이 나오면 fetchRounds 호출 (10개씩 가져옴)
                    await this.fetchRounds(round + 1);
                    if (this.cache.has(round)) {
                        results.push(this.cache.get(round));
                    }
                    else {
                        break;
                    }
                }
            }
            return results;
        }
        clearCache() {
            this.cache.clear();
            localStorage.removeItem(this.CACHE_KEY);
        }
    };
    LottoServiceImpl = __decorate([
        Sim({ symbol: LottoService.SYMBOL, container: container }),
        __metadata("design:paramtypes", [])
    ], LottoServiceImpl);
    return LottoServiceImpl;
};
